import { CalendarItemModel } from 'shared/models';

type CalendarDayRowType = {
    calendarDayColumns: CalendarDayRowColumnType[];
    startAtMinutes: number;
    endAtMinutes: number;
};

type CalendarDayRowColumnType = {
    calendarItems: CalendarItemModel[];
    startAtMinutes: number;
    endAtMinutes: number;
};

const findCalendarItemForCalendarDayRow = (calendarDayRow: CalendarDayRowType, calendarItems: CalendarItemModel[]) => {
    return calendarItems.find(calendarItem => {
        if (calendarDayRow.endAtMinutes === -1) {
            return true;
        }

        if (calendarDayRow.startAtMinutes <= calendarItem.startAtMinutes && calendarItem.startAtMinutes <= calendarDayRow.endAtMinutes) {
            return true;
        }

        if (calendarDayRow.startAtMinutes <= calendarItem.endAtMinutes && calendarItem.startAtMinutes <= calendarDayRow.endAtMinutes) {
            return true;
        }

        return false;
    });
};

/**
 * @description сначала группируем все элементы по строкам, потом эти элементы разбиваем по столбцам сложность O(log(n3))
 * @param calendarItems
 */
export const getCalendarDayRows = (calendarItems: CalendarItemModel[]): CalendarDayRowType[] => {
    const calendarDayRows: CalendarDayRowType[] = [];
    let currentCalendarItems: CalendarItemModel[] = [...calendarItems.sort((a, b) => a.startAtMinutes - b.startAtMinutes)];
    while (currentCalendarItems.length > 0) {
        let calendarDayRow: CalendarDayRowType = {
            calendarDayColumns: [],
            startAtMinutes: 999999,
            endAtMinutes: -1,
        };
        let calendarItem = findCalendarItemForCalendarDayRow(calendarDayRow, currentCalendarItems);
        while (calendarItem !== undefined) {
            const find =
            calendarDayRow.startAtMinutes = Math.min(calendarDayRow.startAtMinutes, calendarItem.startAtMinutes);
            calendarDayRow.endAtMinutes = Math.max(calendarDayRow.endAtMinutes, calendarItem.endAtMinutes);

            // try to find existed column that fits current calendar item
            let calendarDayColumn = calendarDayRow.calendarDayColumns.find(calendarDayColumn => {
                return calendarItem && calendarItem.startAtMinutes >= calendarDayColumn.endAtMinutes;
            });
            if (calendarDayColumn) {
                calendarDayColumn.calendarItems.push(calendarItem);
                calendarDayColumn.startAtMinutes = Math.min(calendarDayColumn.startAtMinutes, calendarItem.startAtMinutes);
                calendarDayColumn.endAtMinutes = Math.max(calendarDayColumn.endAtMinutes, calendarItem.endAtMinutes);
            } else {
                calendarDayRow.calendarDayColumns.push({
                    calendarItems: [calendarItem],
                    startAtMinutes: calendarItem.startAtMinutes,
                    endAtMinutes: calendarItem.endAtMinutes,
                });
            }

            currentCalendarItems = currentCalendarItems.filter(item => item.id !== calendarItem?.id);
            calendarItem = findCalendarItemForCalendarDayRow(calendarDayRow, currentCalendarItems);
        }

        calendarDayRows.push(calendarDayRow);
    }

    return calendarDayRows;
};
